module.exports = __webpack_public_path__ + "static/media/v3.375e7256.JPG";